import { render, staticRenderFns } from "./stydyList.vue?vue&type=template&id=431805e1&scoped=true"
import script from "./stydyList.vue?vue&type=script&lang=js"
export * from "./stydyList.vue?vue&type=script&lang=js"
import style0 from "./stydyList.vue?vue&type=style&index=0&id=431805e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431805e1",
  null
  
)

export default component.exports